import { motion } from 'framer-motion';

const TrustIndicators = () => {
  const partners = [
    'Maersk',
    'MSC',
    'CMA CGM',
    'Emirates SkyCargo',
    'Lufthansa Cargo',
    'DHL',
    'FedEx',
    'UPS',
  ];

  return (
    <section className="bg-gray-50 py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-gray-500 text-sm font-medium uppercase tracking-wider mb-8">
          Trusted by Leading Global Partners
        </p>
        <div className="flex items-center justify-center gap-12 flex-wrap">
          {partners.map((partner, index) => (
            <motion.div
              key={partner}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-2xl font-bold text-gray-400 hover:text-primary-blue transition-colors cursor-pointer whitespace-nowrap"
            >
              {partner}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;